import { useMutation } from '@tanstack/react-query';

import { UpdatePasswordPayload } from '../../../../../types/requests';
import { handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { postUpdatePassword } from '../../requests/postUpdatePassword';

export const useUpdatePassword = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation({
    mutationFn: (data: UpdatePasswordPayload) =>
      postUpdatePassword(constructPost, data),
    onSuccess: () =>
      handleSuccess('Success!', 'Your password has been changed successfully!'),
  });
  return { updatePassword: mutateAsync, ...rest };
};
